$(document).ready(function () {

    $(".hamburger").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        if ($(this).hasClass("is-active")) {
            $(this).find('.text').html('Menu');
        } else {
            $(this).find('.text').html('Close');
        }
        $(this).toggleClass("is-active");

        $('.menu-header-mobile').toggleClass('open');
        $('body').toggleClass('overflow-hidden');
    });

    function closeMobileMenu() {
        $('.hamburger').removeClass('is-active');
        $('.menu-header-mobile').removeClass('open');
        $('body').removeClass('overflow-hidden');
        $('.hamburger .text').text('Menu'); 
    }

    $(document).on('click', '[data-bs-toggle="modal"][data-bs-target="#sim"]', closeMobileMenu);
    $('#sim').on('show.bs.modal', closeMobileMenu);

    $(window).on("scroll", function () {
        $("body").toggleClass("down", ($(window).scrollTop() > 180));
    });

    if ($('body').hasClass('has-loading')) {
        $('.loading-container').delay(500).fadeOut(400);
        setTimeout(() => {
            AOS.init({
                duration: 1000, // values from 0 to 3000, with step 50ms
                easing: 'ease', // default easing for AOS animations
            });
        }, 1000);
    } else {
        AOS.init({
            duration: 1000, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
        });
    }

    var productsSwiper = new Swiper(".productsSwiper", {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    var defaultSwiper = new Swiper(".defaultSwiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1600: {
                slidesPerView: 4,
                spaceBetween: 45,
            },
        },
    });

    var testiSwiper = new Swiper(".testiSwiper", {
        // scrollbar: {
        //     el: ".swiper-scrollbar",
        //     draggable: true,
        // },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 20,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1.8,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 2.5,
                spaceBetween: 45,
            },
        },
    })
})